module.exports = __webpack_public_path__ + "img/ask_ai.2e37a380.svg";